import { render } from "./CookiePolicy.vue?vue&type=template&id=4dd13858&scoped=true&ts=true"
import script from "./CookiePolicy.vue?vue&type=script&lang=ts"
export * from "./CookiePolicy.vue?vue&type=script&lang=ts"

import "./CookiePolicy.vue?vue&type=style&index=0&id=4dd13858&lang=scss&scoped=true"

import exportComponent from "/Users/suhwanlim/Projects/pr/MoTobi-Web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dd13858"]])

export default __exports__